export default function FilterButton(props) {
    const type = props.type;
    const showIconBadge = props.nrOfCheckedCheckboxes > 0 ? true : false

    return (
        <button data-badge-number={showIconBadge ? props.nrOfCheckedCheckboxes : ''} className={showIconBadge ? 'button-filter collapsed button-icon icon-filter icon-badge' : 'button-filter collapsed'} data-bs-toggle="collapse" data-bs-target={`#${type}`} aria-controls={type} aria-expanded="false"><span className="visually-hidden">Filtrera på </span>{props.buttonName}</button>
    );
}